import { render, staticRenderFns } from "./comment-form.vue?vue&type=template&id=18d3d7e2&lang=pug&"
import script from "./comment-form.vue?vue&type=script&lang=js&"
export * from "./comment-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports